<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="120px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述（中文）" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.zhMatName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述（英文）" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.enMatName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类别" class="EL-Form-Item">
                        <el-select v-model="pagination.itemClass" clearable placeholder="请选择">
                            <el-option v-for="item in mdTypeList" :key="item.ddId" :value="item.ddCode" :label="item.ddCode+'-'+item.ddName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="型号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.model">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="间材信息">
                <el-button :loading="!!loading" v-authority="'BACK_MENU4_M8_B1'" class="btn-t-edit" @click="openInsert">新增</el-button>
                <el-button v-authority="'BACK_MENU4_M8_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="zhMatName" label="物料描述（中文）" />
                <el-table-column prop="enMatName" label="物料描述（英文）" />
                <el-table-column prop="whCode" label="通道" />
                <el-table-column prop="itemClass" label="类别" />
                <el-table-column prop="model" label="型号" />
                <el-table-column prop="abbreviation" label="简称" />
                <el-table-column prop="parameter" label="参数" />
                <el-table-column prop="status" label="库存状态" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU4_M8_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" 
                        @click="(add_or_edit = false),(editBoxShow = true),(mainObj = JSON.parse(JSON.stringify(scope.row)))" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU4_M8_B3'" type="danger" @click="deleteRow(scope.row.smdId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" @close="close" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.matCode" maxlength="20"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料描述（中文）" prop="zhMatName" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.zhMatName" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料描述（英文）" prop="enMatName" class="EL-Form-Item">
                            <el-input v-model="mainObj.enMatName" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="通道" prop="whCode" class="EL-Form-Item">
                            <el-select filterable v-model="mainObj.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="item in whCodeList" :key="item.whId" :label="item.whCode +' - ' + item.whName" :value="item.whCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="类别" prop="itemClass" class="EL-Form-Item">
                            <el-input v-model="mainObj.itemClass" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="型号" prop="model" class="EL-Form-Item">
                            <el-input v-model="mainObj.model" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="简称" prop="abbreviation" class="EL-Form-Item">
                            <el-input v-model="mainObj.abbreviation" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="参数" prop="parameter" class="EL-Form-Item">
                            <el-input v-model="mainObj.parameter" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库存状态" prop="status" class="EL-Form-Item">
                            <el-select v-model="mainObj.status" placeholder="请选择">
                                <el-option label="库存" value="库存"></el-option>
                                <el-option label="非库存" value="非库存"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="close">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "StockCheckTaskDetail",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    matCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    // matName: [{
                    //     required: true,
                    //     message: "请输入",
                    //     trigger: "blur",
                    // }, ],
                    whCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    // mtType: [{
                    //     required: true,
                    //     message: "请输入",
                    //     trigger: "blur",
                    // }, ],
                    validityMonth: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                mtTypeList: [], //物料类型集合

                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    matCode: "",
                    zhMatName: "",
                    enMatName: "",
                    itemClass:"",
                    model: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                },
				tableTotal:0,
                mainData: [],
                fcode: localStorage.getItem("fcCode") || "",

                downloadLoading: false, //下载中

                loading: 0,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                whCodeList: [],

                //所有类别
                mdTypeList:[],
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                // this.loading++
                this.$http
                    .request({
                        url: "/api/material/getMaterialDetailList",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        // this.loading--
                        if (resp.status == 100) {
                            // console.log(resp.data.list.length);
                            this.mainData = resp.data.list || [];
                            this.tableTotal = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        // this.loading--;
                    });
            },
            openInsert(){
                this.add_or_edit = true;
                this.editBoxShow = true
                this.getWhCode();
            },
            //获取所有的类别
            getMdType(){
                this.$http
                    .request({
                        url: "/api/dict/getDictTypeByLatypeAll",
                        method: "GET",
                        params: {
                            pageSize: 0,
                            pageNum: 0,
                            dtCode: "MDTYPE",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mdTypeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });    
            },
            //获取通道
            getWhCode() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouseAll",
                        method: "GET",
                        params: {
                            pageSize: 0,
                            pageNum: 0,
                            whCode: "",
                            whName: "",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.whCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取类型
            getmtTypeList() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "MDTYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.mtTypeList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getAuxiMaterialData();
                }
            },
            close(){
                this.$refs.mainObj.clearValidate()
                this.mainObj = {};
                this.editBoxShow = false;
            },
            //新增
            add() {
                if (this.fcode != "") {
                    this.mainObj.fcCode = this.fcode;
                }
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/material/insertMaterialDetail",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "material：物料新增失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t mtName" +
                                this.mainObj.mtName;
                            this.systemLog();
                            // this.editBoxShow = false;
                            this.close();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/material/updateMaterialDetail",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料编辑成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "material：物料编辑失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t mtName" +
                                this.mainObj.mtName;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(smdId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/material/deleteMaterialDetail",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    smdId: smdId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "material：间材信息删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "material：间材信息删除失败";
                                }
                                this.logContent = "smdId" + smdId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    matCode: "",
                    zhMatName: "",
                    enMatName: "",
                    itemClass:"",
                    model:"",
                    fcCode: localStorage.getItem("fcCode") || "",
                },
				this.tableTotal=0;
                // this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    matCode: this.pagination.matCode,
                    zhMatName: this.pagination.zhMatName,
                    enMatName: this.pagination.enMatName,
                    itemClass: this.pagination.itemClass,
                    model: this.pagination.model,
                    fcCode: localStorage.getItem("fcCode") || "",
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/material/getMaterialDetailList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    // list.forEach(function(c) {

                    // })
                    const tHeader = ['物料编号', '物料描述（中文）', '物料描述（英文）', '通道', '类别','型号', '简称', '参数','库存状态']
                     const filterVal = ['matCode', 'zhMatName', 'enMatName', 'whCode', 'itemClass', 'model', 'abbreviation','parameter','status']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '间材信息'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_material_detail：导出间材信息"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料主数据",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated() {
            this.getmtTypeList()
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            this.getMdType();
        },
    };
</script>

<style scoped>
</style>